/* dialog */
const app = document.querySelector<HTMLElement>('#app');
/*--------------------------------------------------------------------------------*/
export const confirm = (
    message: string,
    params?: {
        color?: string;
        target?: HTMLElement;
    }
) => new Promise<boolean>((resolve) => {
    if (!app) return;
    const doc = params && params?.target ? params.target : app;
    const color = params && params?.color ? params.color : 'green';
    // create
    const dialog = document.createElement('div');
    dialog.className = 'overlay slim-dialog';
    dialog.innerHTML = /*html*/ `
        <div class="confirm ${color}">
            <div class="header">
                <i class="icon solid">&#xf058;</i> Slim Confirm
            </div>
            <div class="message">${message}</div>
            <div class="footer">
                <button class="lg gray left" id="btn-no">
                    <i>&#xf057;</i>ยกเลิก
                </button>
                <button class="lg ${color} right" id="btn-yes">
                    <i>&#xf058;</i>ตกลง
                </button>
            </div>
        </div>
    `;
    doc.appendChild(dialog);
    // button
    dialog.querySelector<HTMLButtonElement>('#btn-yes')!.focus();
    dialog.querySelector<HTMLButtonElement>('#btn-yes')!.onclick = () => {
        dialog.remove();
        resolve(true);
    };
    dialog.querySelector<HTMLButtonElement>('#btn-no')!.onclick = () => {
        dialog.remove();
        resolve(false);
    };
});
/*--------------------------------------------------------------------------------*/
export const alert = (
    message: string,
    params?: {
        type?: string;
        target?: HTMLElement;
    }
) => new Promise<void>((resolve) => {
    if (!app) return;
    const doc = params && params?.target ? params.target : app;
    const type = params && params?.type ? params.type : 'success';
    // type
    let color = '';
    let icon = '';
    if (type == 'success') { color = 'green'; icon = '&#xf058;'; }
    if (type == 'failure') { color = 'red'; icon = '&#xf057;'; }
    if (type == 'warning') { color = 'orange'; icon = '&#xf06a;'; }
    if (type == 'info') { color = 'blue'; icon = '&#xf05a;'; }
    // create
    const dialog = document.createElement('div');
    dialog.className = 'overlay slim-dialog';
    dialog.innerHTML = /*html*/ `
        <div class="alert ${color}">
            <div class="icon solid">${icon}</div>
            <div class="message">${message}</div>
            <div class="footer">
                <button class="lg ${color}" id="btn-yes">ตกลง</button>
            </div>
        </div>
    `;
    doc.appendChild(dialog);
    // button
    dialog.querySelector<HTMLButtonElement>('#btn-yes')!.focus();
    dialog.querySelector<HTMLButtonElement>('#btn-yes')!.onclick = () => {
        dialog.remove();
        resolve();
    };
});
/*--------------------------------------------------------------------------------*/
export const toast = (
    message: string,
    params?: {
        type?: string;
        target?: HTMLElement;
    }
) => new Promise<void>((resolve) => {
    if (!app) return;
    const doc = params && params?.target ? params.target : app;
    const type = params && params?.type ? params.type : 'success';
    // type
    let color = '';
    let icon = '';
    if (type == 'success') { color = 'green'; icon = '&#xf058;'; }
    if (type == 'failure') { color = 'red'; icon = '&#xf057;'; }
    if (type == 'warning') { color = 'orange'; icon = '&#xf06a;'; }
    if (type == 'info') { color = 'blue'; icon = '&#xf05a;'; }
    // create
    const toast = document.createElement('div');
    toast.className = `slim-toast ${color}`;
    toast.innerHTML = /*html*/ `
        <i class="icon">${icon}</i>
        <span class="text">${message}</span>
    `;
    doc.appendChild(toast);
    // animation
    toast.classList.add('show');
    let count = 0;
    toast.onanimationend = () => {
        count++;
        if (count == 2) {
            toast.remove();
            resolve();
        }
    };
});
/*--------------------------------------------------------------------------------*/
